import { useContext, useEffect, useMemo } from 'react';
import { useJwtClaims } from '../Context/AuthContext';
import { ProfileContext } from '../Context/ProfileContext';

// eslint-disable-next-line import/prefer-default-export
export const useProfileShare = (applicationUserId?: number | null) => {
  const { userId } = useJwtClaims();
  const { bookitupTeam } = useContext(ProfileContext);
  const { shares } = bookitupTeam;
  const appUserId = applicationUserId === null ? undefined : applicationUserId ?? userId ?? undefined;

  const profileShare = useMemo(
    () => shares.find((share) => share.applicationUserId === appUserId),
    [appUserId, shares],
  );
  const hasValidEmailAccount = useMemo(
    () => (profileShare?.availableMailAccounts?.length ?? 0) > 0,
    [profileShare?.availableMailAccounts],
  );

  useEffect(() => {
    if (!appUserId) {
      return undefined;
    }

    bookitupTeam.ensureSharesLoaded().catch(() => undefined);
    return undefined;
  }, [appUserId, bookitupTeam]);

  return { profileShare, hasValidEmailAccount };
};
